import clsx from '@appvantageasia/core-utils/clsx';

interface LoaderProps {
    height?: 'auto' | 'screen';
}

const Loader = ({ height = 'auto' }: LoaderProps) => (
    <div
        className={clsx(
            'flex items-center justify-center p-3',
            height === 'auto' && 'h-auto',
            height === 'screen' && 'h-screen'
        )}
    >
        <div
            className={`border-primary h-10 w-10 animate-spin rounded-full border-4 border-solid border-t-transparent`}
        />
    </div>
);

export default Loader;
